import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">常见问题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于桃子视频的常见疑问，这里有答案</p>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-lg border border-background-200/60 overflow-hidden">
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.question}</h3>
                <i
                  className={`text-lg text-foreground-400 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}